import React from 'react';

export default function Footer() {
    return (
        <div className="background-block background-block__footer">
            <footer>
                <div>Copyright 2024 - Réalisé par Tom Tournillon. Tous droits réservés.</div>
                {/* <div>
                    <ul className="links">
                        <li>Mentions légales</li>
                        <li>Politique de confidentialité</li>
                        <li>Politique des cookies</li>
                    </ul>
                </div> */}
            </footer>
        </div>
    )
}